import {useCallback} from 'react';

import {useNavigate} from 'react-router-dom';
import {ServicesEnum} from 'presentation/constants';

export function useFranchisesTable() {
	const navigate = useNavigate();

	const handleBack = useCallback(() => {
		navigate(ServicesEnum.SERVICES);
	}, []);

	return {
		handleBack,
	};
}
